// hooks/usePlatformUsers.js

import { useState, useEffect } from "react";
import { useTableDataWithPost } from "hooks/useTableWithPost";
import { fetchWrapper } from "utils/apiFetch";

const API_URL = "https://pro.mokshiq.in/platform_user_action";

// ── Re-export useTableDataWithPost for platform users ─────────────────────
// Usage in page (identical to MemberManagementPage):
//
//   const tableData = useTableDataWithPost(
//     "https://pro.mokshiq.in/platform_user_action",
//     PlatformUserManagement,
//     formdata,
//     refresh
//   );
//   <DataTable config={PlatformUserManagement} tableData={tableData} ... />

export { useTableDataWithPost as usePlatformUsers };

// ── Module flags hook — for NavigationBar platform_user role ──────────────

let _moduleCache = null;

export function usePlatformModules() {
  const role = localStorage.getItem("role") || "";
  const [modules, setModules] = useState(_moduleCache || {});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (role !== "platform_user") return;
    if (_moduleCache) { setModules(_moduleCache); return; }

    setLoading(true);
    const fd = new FormData();
    fd.append("action", "GET_MY_MODULES");

    fetchWrapper(API_URL, { method: "POST", body: fd })
      .then((res) => {
        const m = res?.data || {};
        _moduleCache = m;
        setModules(m);
      })
      .catch(() => setModules({}))
      .finally(() => setLoading(false));
  }, [role]);

  return { modules, loading };
}

export function clearPlatformModuleCache() {
  _moduleCache = null;
}

// ── Mutation helpers ──────────────────────────────────────────────────────

async function post(fd) {
  return fetchWrapper(API_URL, { method: "POST", body: fd });
}

export async function createPlatformUser(payload) {
  const fd = new FormData();
  fd.append("action", "CREATE");
  Object.entries(payload).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") fd.append(k, v);
  });
  return post(fd);
}

export async function updatePlatformUser(puId, payload) {
  const fd = new FormData();
  fd.append("action", "UPDATE");
  fd.append("pu_id", puId);
  Object.entries(payload).forEach(([k, v]) => {
    if (v !== undefined && v !== null) fd.append(k, v);
  });
  return post(fd);
}

export async function deactivatePlatformUser(puId) {
  const fd = new FormData();
  fd.append("action", "DEACTIVATE");
  fd.append("pu_id", puId);
  return post(fd);
}

export async function fetchAuditLogs() {
  const fd = new FormData();
  fd.append("action", "GET_AUDIT");
  return post(fd);
}